export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">有爆料线索或合作意向？欢迎随时联系我们</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/60">
            <span className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mx-auto mb-4">
              <i className="ri-mail-line text-xl text-accent-600"></i>
            </span>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">投稿爆料</h3>
            <p className="text-sm text-foreground-600">将你的爆料线索发送至</p>
            <p className="text-sm font-medium text-primary-600 mt-1">tips@chigua.example.com</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/60">
            <span className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mx-auto mb-4">
              <i className="ri-group-line text-xl text-accent-600"></i>
            </span>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-600">广告投放与品牌合作请联系</p>
            <p className="text-sm font-medium text-primary-600 mt-1">biz@chigua.example.com</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/60">
            <span className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mx-auto mb-4">
              <i className="ri-questionnaire-line text-xl text-accent-600"></i>
            </span>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">意见反馈</h3>
            <p className="text-sm text-foreground-600">网站建议或问题反馈</p>
            <p className="text-sm font-medium text-primary-600 mt-1">feedback@chigua.example.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}